import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { AlertHelpDialog } from '@iris-platform/iris-react-ui';
import { propOr } from 'ramda';
import { Query, withApollo } from 'react-apollo';
import { withSnackbar } from 'notistack';
import applicationPropType from '../applicationPropType';
import CurrentOwner from './CurrentOwner';
import TransferUser from './TransferUser';
import TransferTeam from './TransferTeam';
import { GET_APPLICATION_OWNER, UPDATE_APPLICATION_OWNER } from '../queries';
import Helpfile from '../helpfile.json';
import {
  stylesToPropType,
} from '../../../utils';

const styles = () => ({
  root: {},
  hrText: {
    lineHeight: '1em',
    position: 'relative',
    outline: '0',
    border: '0',
    color: '#000',
    textAlign: 'center',
    height: '1.5em',
    opacity: '.5',
  },
  icon: {
    // margin: theme.spacing.unit,
    fontSize: 14,
    cursor: 'pointer',
  },
  iconbutton: {
    width: '18px',
    height: '18px',
  },
});

class TransferTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      saving: false,
      titleOwner: 'Current Owner',
      titleTransfer: 'Transfer To',
      open: false,
      dialogTitle: '',
      dialogContent: '',
    };
  }

  handleHelpOpen = (title, content) => {
    this.setState({
      open: true,
      dialogTitle: title,
      dialogContent: content,
    });
  };

  handleHelpClose = () => {
    this.setState({
      open: false,
      dialogTitle: '',
      dialogContent: '',
    });
  };

  reloadApp = async (ownerId, appId) => {
    const { client, enqueueSnackbar } = this.props;

    this.setState({ saving: true });
    try {
      await client.mutate({
        mutation: UPDATE_APPLICATION_OWNER,
        variables: {
          appid: appId,
          newownerID: ownerId,
        },
      });
      enqueueSnackbar('Owner successfully updated', { variant: 'success' });
      this.setState({ saving: false });
    } catch (error) {
      enqueueSnackbar('Owner failed to update', { variant: 'error' });
      this.setState({ error });
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const { classes, application } = this.props;
    const {
      titleOwner,
      titleTransfer,
      saving,
      open,
      dialogTitle,
      dialogContent,
    } = this.state;
    const help = Helpfile.transfer;

    return (
      <Query
        query={GET_APPLICATION_OWNER}
        notifyOnNetworkStatusChange
        // variables={{ applicationID: {propOr([], 'applications.applicationID', application)}
        variables={{ applicationID: application.applicationID }}
      >
        {({ data, loading, error }) => {
          if (loading) return null;
          if (error) return `Error!: ${error}`;
          const {
            _id: id,
          } = data.applicationOwner;

          return (
            <Fragment>
              <Typography
                component="div"
                variant="subheading"
                gutterBottom
              >
                {titleOwner}
                <IconButton className={classes.iconbutton} aria-label="Delete" onClick={() => this.handleHelpOpen(help.currentOwner.title, help.currentOwner.content)}>
                  <HelpOutlineIcon className={classes.icon} />
                </IconButton>
              </Typography>
              <br />
              <CurrentOwner
                appKey={application.clientID}
                application={application}
                ownerId={propOr('', 'ownerID', data.applicationOwner)}
              />
              <br />
              <br />
              <Typography
                component="div"
                variant="subheading"
                gutterBottom
              >
                {titleTransfer}
                <IconButton className={classes.iconbutton} aria-label="Delete" onClick={() => this.handleHelpOpen(help.transferTo.title, help.transferTo.content)}>
                  <HelpOutlineIcon className={classes.icon} />
                </IconButton>
              </Typography>
              <br />
              <TransferUser
                appKey={application.clientID}
                application={application}
                appId={id}
                updateOwner={this.reloadApp}
              />
              <br />
              {/* <hr className={styles.hrText} data-content="OR" /> */}
              <Divider light />
              <br />
              <TransferTeam
                appKey={application.clientID}
                application={application}
                appId={id}
                updateOwner={this.reloadApp}
              />
              <AlertHelpDialog
                handleClose={this.handleHelpClose}
                open={open}
                dialogTitle={dialogTitle}
                dialogContent={dialogContent}
              />
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

TransferTab.propTypes = {
  application: applicationPropType.isRequired,
  classes: stylesToPropType(styles()).isRequired,
  client: PropTypes.object.isRequired,
};

export default withSnackbar(withApollo(withStyles(styles)(TransferTab)));
